<template>
  <div class="page-container">
    <el-card class="mb-20">
      <app-filter
        :filter-list="table_filter"
        default-label-width="90px"
        @search="search"
      />
    </el-card>
    <el-card>
      <app-table
        ref="table"
        :table-key="table_key"
        :tablep="table_params"
        :get-data="getOperationLogList"
      />
    </el-card>
  </div>
</template>

<script>
import { getOperationLogListApi } from '@/api/system/operation-log';

/** 需要参与筛选的参数，用于清空条件时移除旧值 */
const FILTER_KEYS = ['username', 'methods', 'path', 'ip', 'status_codes', 'min_duration', 'start_time', 'end_time'];

export default {
  components: {
    'app-table': () => import('@/components/app-table'),
    'app-filter': () => import('@/components/app-filter'),
  },
  data() {
    return {
      /** 过滤项 */
      table_filter: require('./model/table-filter')(),
      /** 表头数据 */
      table_key: require('./model/table-key')(this),
      /** 表格请求参数 */
      table_params: {
        page: 1,
        limit: 10,
      },
    };
  },
  methods: {
    /**
     * 搜索
     * @param {Object} params 过滤参数
     */
    search(params) {
      const { date, ...rest } = params;
      const query = {};

      // 请求时间范围拆分为开始、结束时间
      if (Array.isArray(date) && date.length === 2 && date[0]) {
        query.start_time = date[0];
        query.end_time = date[1];
      }

      Object.entries(rest).forEach(([key, value]) => {
        // 跳过空值以及空数组（多选清空时）
        if (value === '' || value === null || typeof value === 'undefined' || (Array.isArray(value) && value.length === 0)) {
          return;
        }
        query[key] = value;
      });

      // 响应状态码支持多个，转为数字数组，与后端 status_codes 对齐
      if ('status_codes' in query) {
        const status_codes = String(query.status_codes)
          .split(/[\s,，]+/)
          .filter(Boolean)
          .map(Number)
          .filter(status_code => !Number.isNaN(status_code));
        if (status_codes.length) {
          query.status_codes = status_codes;
        } else {
          delete query.status_codes;
        }
      }

      // 最小请求耗时，后端为数字类型
      if ('min_duration' in query) {
        const min_duration = Number(query.min_duration);
        if (Number.isNaN(min_duration)) {
          delete query.min_duration;
        } else {
          query.min_duration = min_duration;
        }
      }

      // 移除本轮已清空的筛选条件，避免沿用上一次的旧值
      FILTER_KEYS.forEach(key => {
        if (!(key in query)) {
          delete this.table_params[key];
        }
      });

      Object.assign(this.table_params, query);
      this.$refs.table.seekTable();
    },
    /**
     * 获取操作日志列表
     * @param {Object} data 查询参数
     * @returns {Promise<Object>}
     */
    getOperationLogList(data) {
      return new Promise((resolve, reject) => {
        getOperationLogListApi(data)
          .then(resolve)
          .catch(reject);
      });
    },
    /**
     * 格式化请求参数
     * 敏感字段已由后端脱敏；请求参数超过 1MB 被截断时后端返回字符串，需原样展示
     * @param {Object|string} params 请求参数
     * @returns {string}
     */
    formatParams(params) {
      if (typeof params === 'string') {
        return params || '-';
      }
      if (params && typeof params === 'object') {
        try {
          return JSON.stringify(params, null, 2);
        } catch (error) {
          return String(params);
        }
      }
      return '-';
    },
  },
};
</script>
